/**
 * sessionStorageのキーはグローバルなため一括管理する
 *
 * ベタで並べていく想定で作成しているが、今後Namespace的なものが必要になったらそのときに再構成する
 */
export const sessionStorageKeys = {
  uiScheduledReportSummariesScrollY: 'ui_scheduled_report_summaries_scroll_y',
  uiReportListScrollY: 'ui_report_list_scroll_y',
}
